export default __webpack_public_path__ + "img/57910da06c20609b130d8586217102e5.svg";